module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Nerves prickled on the back of his neck as Nick St. Claire climbed the steps in the Brooklyn apartment building two at a time. The heavy smell of garlic and onion filled the air in front of apartment 12-C, masking any other scents. His stomach growled, but he kept moving down the hallway to 12-H. He hadn’t eaten in twelve hours, but now wasn’t the time to remember unnecessary details.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His boss and friend, Royce Fontaine, moved on silent feet behind him. As a Stealth Operations Specialist, trained in all forms of warfare, including military operations in urban terrain, Nick understood the necessity of speed and surprise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This mission wasn’t dictated by the government as usual with the SOS agency. The unauthorized, late-night flight on the SOS private Learjet had been in response to an e-mail message from Royce’s old Army buddy. Need your help. Life or death. Come now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royce had dropped everything, including an important case regarding death threats against a U.S. senator. He’d grabbed Nick on his way out the door of the SOS offices in downtown D.C., shouting for Tazer, one of the very capable female SOS agents, to cover for him while he flew to New York.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When Nick arrived at the door to 12-H, splintered wood didn’t bode well for what might be inside. He pulled the SIG-Sauer from the shoulder holster beneath his leather jacket and nodded to Royce. Then he plastered his body against the wall and pushed the door open wider.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Every piece of furniture was turned over or ripped; the room was a shambles. Nothing stirred in the living space, but a noise from a back room alerted Nick that they weren’t alone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He slipped in first, followed by Royce. In a low crouch, Nick swept the room with his gaze for bogeys before he entered the hallway.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A weak moan echoed off the walls in the bathroom to the right.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Glass shattered, followed by a metallic clanging in the room to the left.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick pointed at Royce and then to the bathroom. He then pointed at himself and the room with the clanging noise. Without waiting for his boss’s response, Nick leaped over scattered clothing, books and tables and burst into a bedroom, weapon at the ready. Whoever had broken the window was probably down the fire escape by now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not without backup, St. Claire!” Royce hissed behind him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick ignored Royce, not stopping until he reached the window. He paused beside the broken glass, peering around the wooden frame, careful to limit his exposure to gunfire, not at all anxious to take a bullet. The clang of feet jumping down the fire escape stairs reassured him that whoever was on them was in a hurry to be gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Using the barrel of his weapon, Nick swept the jagged window glass to the side and leaned out just in time to catch a glimpse of a broad-shouldered person dressed in black moving down the steps of the three-story apartment building. Nick swore. Almost to the ground, the guy would escape into the maze of dark city streets before Nick or Royce could do anything about it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("To hell with that. Nick slid through the window and descended the steps two at a time. The noise of his shoes hitting the steel was deafening, but not so bad that he didn’t hear the ominous popping sound of shots being fired or the ping of bullets ricocheting off the brick near his head. He kept moving. If he stopped, the shooter would have time to make good his aim.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A bullet glanced off the metal railing next to his leg. Another sprayed pieces of masonry over his head.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick didn’t slow. Gun ready, he hit the ground feet first and performed a perfect airborne drop and roll, grateful for the thick leather jacket covering his elbows and back. He clambered to his feet and took off in a zigzag run, bullets flying around him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The man in black rounded a corner, disappearing out of sight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick stuck to the shadows and ran the length of a building to the same corner. He stopped, poked his head out and saw nothing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Streetlights shone down on an empty avenue. The only movement was a lone car heading his way at a slow speed. Nick ducked back behind the building in case the car contained the assailant. When it pulled to the curb and shut down, an old man dressed in khaki slacks, a light blue sweater and orthopedic shoes climbed out and reached into the back for a bag of groceries. He carefully locked the door and headed into the building.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick stepped out into the street, tucking his weapon back in the holster under his arm. He kept his hand on the grip, ready for anything.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He walked quickly down the street searching for the man dressed in black, but didn’t see him. Damn, he’d slipped away. Nothing he could do about it now but go see if Royce needed help.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Retracing his steps, Nick found his way back to the apartment and entered through the front door, climbing the steps to the third floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When Nick entered the destroyed apartment, Royce was on his cell phone to the local police giving enough details to get them started. When he’d completed the call, he flipped his phone shut and slipped it into his pocket. “Got away?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah, he had a head start.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The gunfire. Yours or his?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“His.” Nick didn’t fire his weapon randomly, especially not in populated urban areas where stray bullets could take innocent lives. “Who was the moaner?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royce’s jaw tightened. “Frank Richards.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The guy we came to help?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A snort was Royce’s only answer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Damn. Did he give you a clue as to who might have done it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His boss shook his head, a frown drawing his brows together. “He died without uttering another word. But I found this and a pen lying on the bathroom floor close by.” Royce held up a small pad of paper with a page half ripped off. “I think whoever shot him took the message.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let me see that.” Nick took the pad and tipped it back and forth until the light cast enough shadow over where the pen had dented the pages below the missing one. “What does it say?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“North Pole, AX or AK. Help Santa.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick barked out a mirthless laugh. “The man was clearly delusional. Already in the throes of death.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. He wrote it before he was shot. There’s no blood on the pad or the pen and his fingers had blood on them when he died. I think he means for us to help someone.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There is a town in Alaska named North Pole. It’s close to Fairbanks. You suppose that’s what he was talking about?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Maybe.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why there? Santa a code word for something?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know. What I do know is that whoever did this was after something, and I’d bet my reputation they didn’t find it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And they weren’t afraid to kill for it.” Nick stared down at the man lying on the floor, his face pale and tinged gray. “You think our shooter will look in North Pole, Alaska, next?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perhaps.” Royce’s gaze fell to the man lying on the floor. He wore a New York Knicks sweatshirt and jeans.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How did you two meet?” Nick moved to the living area.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royce followed, the pad in his hand. “I met Sergeant Major Richards during my Navy SEALs training. He was a member of the Army Special Forces assigned to participate as a subject matter expert in a joint exercise we were involved in after Vietnam. We had a few beers after the training and since then, I’ve always kept in touch. When I’d come up to New York, I made it a point to look him up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A computer sat on a desk in the corner, with several bullet holes in the CPU.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Look at this.” Nick bent to examine it. “Any reason why a shooter would target a man and his computer?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll have Tim look into it.” Royce jerked the cord out of the wall and unhooked the CPU from the monitor. “In the meantime, I want you up in Alaska. If they were after something and didn’t find it, there’s a chance that’s where they’ll look.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick shivered just thinking about the cold. “Couldn’t he have chosen Florida or Texas?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Whoever killed Frank might kill in Alaska.” Royce pushed back his shoulders and stared toward the bathroom where his buddy lay. “I want you there ASAP. I’d go with you, but I’ve got another case on the hot plate. Soon as I can, I’ll join you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What am I looking for?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Royce glanced at the pad. “Start with Santa.”")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“F"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("IRST NAME, PLEASE")])]), _vm._v(".” The agent behind the counter stared at the computer, fingers poised for input.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mary.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Last name.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary sucked in a deep breath and let it out. When you had a last name like hers, you did a lot more explaining than if you were christened with a name like Jones, Smith or Henderson. “Christmas.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Both clerks working the busy Fairbanks Airport car rental counter looked up at once, a smile on their faces. Even the good-looking guy in the black Stetson next to her shot a glance her way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Why couldn’t her parents have given her a different name? Did they know how hard it was growing up with a name like Mary Christmas?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary sighed. If her father hadn’t been so supportive, full of energy and the spirit of Christmas, she might have been a lot less adjusted. But the truth was she was a member of the family who owned a store called Christmas Towne in North Pole, Alaska, and that was how things were. Or they were until her mother died. Then it had been just her and her father to carry on the Christmas Towne legacy. Mary had tried hard to fill the void her mother left to the point she’d forgotten to have a life of her own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Here’s your keys.” The clerk waiting on the man next to her handed him a map. “Do you need directions, sir?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, how do I get to North Pole from here?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary cast another glance his way. Nice. Very nice. And going to North Pole. Too bad his hat would blow off the first second he stepped out into the Alaska wind. And too bad she wasn’t interested. Nice-looking men tended to lie and break girls’ hearts. Or at least this girl’s heart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d almost refused to come home for Christmas this year, preferring to stay in the tiny apartment she’d rented in Seattle. If not for the desperate message from her father insisting he needed to talk to her, she’d have skipped Christmas altogether. She hadn’t even bought a tree for her apartment. The whole season, once a happy occasion to be enjoyed with family, was now a depressing time of the year. Christmas without her mother had never been the same. Without her father…well, she might as well skip Christmas altogether. Her dad had Kim now. He didn’t need Mary anymore. Mary should be happy she had a stepmother, but the word "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("stepmother")])]), _vm._v(" made her grind her teeth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not that her stepmother had done anything specifically to earn her distrust; there was just something about the woman that set Mary off. Somehow she had maneuvered her way between Mary and her father from the first.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The devil in Mary’s conscience nagged at her. Could it be because Mary couldn’t get used to the idea of another woman in the house? Or was it because her father had known Kim before he’d ever met Mary’s mother? Kim had been sure to share that information with Mary whenever they were in the same room, claiming she’d known him long before he settled in Alaska. A time Mary’s father had never shared with her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sorry, ma’am. I don’t seem to have a reservation for a Mary Christmas,” the clerk said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know. I flew space A. I didn’t know I was coming until this morning.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Because it’s so close to Christmas, we’ve been booked solid. We don’t have a single car left.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary’s shoulders sagged and her heart sank into her boots. “You’re kidding, right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, ma’am. I wish I wasn’t.” He glanced down the line of rental car counters. “Have you tried the other services here at the airport?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, and they all said the same thing. You were my last hope.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We just rented out the only car we had left to that gentleman.” He nodded to the man wearing the ridiculous cowboy hat walking away with the last set of keys. “I’m sorry. Perhaps you could find a hotel shuttle to get you to a hotel for the night and see if someone turns in a vehicle in the morning.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s not an option. I’m not staying in Fairbanks.” Her gaze locked on the man with the last rental car key. Hadn’t he said he was heading for North Pole? If she hurried, maybe she could catch a ride with him. Once she was there, her father would make sure she had a vehicle to get around in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Balancing her bag of presents in one hand, she turned her rolling suitcase and raced through the airport.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She caught up with him just as he stepped out the door into the continuous twilight of an Alaskan December afternoon. “Sir!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A bitter wind blew her words away, or the man was ignoring her. He didn’t slow one bit until his cowboy hat flipped off his head and blew straight at Mary.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She let go of her suitcase handle and dove for the hat, catching it before it dropped into a pile of dirty snow. She held it out, pasting a smile on her face. She could have tripped on her own snow boots when the man turned his brown-eyed gaze onto her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Thank you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re welcome.” She bit back a smart remark about how most people didn’t wear cowboy hats in December in Alaska. She didn’t know if he had a sense of humor and she definitely didn’t want to make him mad when she planned on begging a ride from him. “Are you headed for North Pole?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He plunked his hat on his head and didn’t answer for the first five seconds. “Yes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Good. He was headed her direction as she’d thought. Mary breathed in a gulp of the icy air. “I’m headed that way myself and you just happened to get the last rental car in the airport. Is there a chance you could give me a lift there?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His frown deepened. “Yes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll pay you half of your daily rate for today.” Mary stopped and stared at him. “You will?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I said yes.” He continued toward the nearly empty rental car parking lot.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary scurried after him, wrapping her woolen scarf around the lower part of her face and pulling her hat more firmly about her ears. She’d forgotten how unforgiving the wind blew in Fairbanks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When they’d settled in the front seat of the sedan, Mary tugged her glove off her right hand. “I’m Mary Christmas. And you are?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instead of taking her hand, he stuck the key in the ignition and started the car. “Nick.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nick?” She closed her eyes so that he couldn’t see her rolling them. “Do you have a last name?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At first she didn’t think he was going to answer. He pushed the shift into Reverse and brushed her arm when he braced his hand on the back of her seat. He was close enough that Mary could smell his aftershave, a potent woodsy, spicy scent. His brown eyes glowed in the light from the dash. “St. Claire.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary caught her breath and stared straight forward.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When Nick had the car in gear, he asked, “Do you know how to get to North Pole?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, I lived there most of my life.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then you can navigate.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Fair enough.” Mary gave him directions and leaned back in her seat, letting the heat warm her hands and cheeks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A small smile curled the corners of Nick’s lips. “Aren’t you afraid to ride with strangers?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If we’d been in Seattle, I would never have imposed on you, but here in Alaska, it’s probably a fair bet you’re not a mass murderer.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I thought people with questionable pasts moved to small towns in Alaska to escape their lives in the Lower 48.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary snorted. “They might think they can escape, but the population is so limited in smaller communities, everyone knows everyone else.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Therefore, if a stranger comes to town, everyone would know him as a stranger?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Right.” She smiled his way. “You’d definitely stick out as a stranger, especially this time of year. In the summer, not so much. Droves of tourists visit North Pole in their RVs and on tour buses, but they eventually leave. Not many people come in the darkness and freezing temperatures of winter.” Her smile slipped. Some people left Alaska on business trips to warmer climates and greener pastures.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her lips pulled into a straight line. She’d been so naïve. That was old news. She’d since moved to Seattle and two years had passed. Mary shook her head to clear the cobwebs and concentrated on the man beside her. “Why are you coming to North Pole? Looking for a place to escape?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Would you believe I have business with Santa?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Maybe.” Mary stared hard at him. Something about the way he said the words didn’t ring true, but she hadn’t heard much from her father in the past few months. Since her father had found a life of his own and the new wife. Kim.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick glanced at her. “What’s Santa’s real name?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The smile returned to Mary’s face. “Santa Claus.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, really. What’s his real name?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“For as long as I can remember, he’s always been Santa Claus. I’ve asked him hundreds of times what his real name was, but he never told me. He signs his name as Santa and his Social Security card and driver’s license all say Santa Claus.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick shook his head, a frown dipping between his brows. “I don’t get it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mary shrugged and settled back against her seat, refusing to fall into the trap of trying to explain the whole North Pole, Alaska, and the Christmas Towne phenomenon. Some people didn’t get it. The man next to her probably never would. His loss.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bradley, the two-timing-bigamist, never understood it either. He’d laughed at the whole concept. He’d probably been laughing at her all along as well. Look at the dumb bumpkin from the sticks of Alaska, too stupid to see through his lies.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The fifteen miles to North Pole flew by. Her heart banged against the inside of her chest when her hometown came into view. Colorful Christmas lights sparkled year-round on the houses and the candy cane lampposts. She never tired of bright colors. Living in Seattle, she missed the cheery lights even in the summertime. As the Christmas Towne store came into view, tears welled in her eyes. Red and white diagonal stripes graced the boxy entrance. Pictures of reindeer and Santa’s sleigh stretched across the whitewashed exterior walls. She hadn’t realized how much she’d missed home until she came back.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This is my stop.” She stared at the building trying to imagine the first impression of a stranger to what she considered home. It looked like a red and white fantasy castle in the middle of the Alaskan landscape. The house beside the store was painted brown and trimmed with fake gumdrops and candy canes; the two buildings could have been out of any child’s most elaborate dream. The little cottage beside the store looked like a gingerbread house good enough to eat, covered in a fluffy foot of snow with drifts up to the windowsills.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A light still shone inside the store. Had her father kept the store open late for the Christmas season? Several cars and a North Pole police SUV stood out front. Christmas Towne had some of the best coffee in North Pole. Many people came all the way out from Fairbanks to eat dinner and buy gifts from the diner and store. They made it a shopping expedition complete with small children anxious to sit in Santa’s lap and tell him all their wishes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If you’ll park in front of the store, I’ll introduce you to my fa—Santa.” When he shifted the car into Park, she grabbed for the handle and jumped out, anxious to ask her father what was so important she had to fly home at the drop of a hat. At the same time, she didn’t want to let Nick get away without finding out what business he had with Santa.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nick popped the latch on the trunk and lifted her suitcase as if it weighed nothing. “I’d appreciate that introduction.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She led the way to the glass doors and entered. Inside, it wasn’t a mob of shoppers she ran into. Instead, she was met by North Pole police officer Trey Baskin and Chris Moss, one of Christmas Towne’s employees, Betty Reedy, the Christmas Towne baker, and her stepmother, Kim Claus.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They stared at her, their gazes shifting to the man beside her as though seeing her with a man was so unusual they were stunned into temporary silence. Mary sighed. So it had been a while since she’d brought a man home to North Pole—two years to be exact. And this one wasn’t even "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("her")])]), _vm._v(" man. “Trey Baskin, Chris Moss, Betty Reedy and Kim Claus, this is Nick St. Claire. He was good enough to give me a lift from the airport.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Chris Moss, the teenager her father had befriended and hired on as full-time staff, was first to stumble forward, his face creased in a worried frown. “Mary, I’m so glad you’re here.” The pale tinge to his young skin set off alarms in Mary’s subconscious. Chris had been the most optimistic teen she’d ever known since her father took him under his wing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What’s going on?” Mary grabbed his hand and held tight, her stomach doing full gainers in a sea of airport food and acid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s Mr. Claus.” Sixteen-year-old Chris squeezed her hand, tears welling in his eyes. He opened his mouth to talk and closed it again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Betty stepped forward, her happy face drawn and looking all of her fifty-five years. “Your father is missing.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340af008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nickoftime_ch01.vue
// module id = 78
// module chunks = 0